import {memo} from 'react';

import {Helmet} from 'react-helmet';

import {getLocalizationService} from '~/shared/services/localisationService';
import MetaHeaders from '~/shared/components/MetaHeaders';
import getTranslationKeysConfig from '~/shared/services/metaTagHelper/translationKeysConfig';

export const PersistentMetaHeaders = memo(() => {
  return (
    <Helmet>
      <meta charSet="utf-8"/>

      <meta property="og:type" content="website"/>

      <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta name="mobile-web-app-capable" content="yes"/>
      <meta name="apple-mobile-web-app-capable" content="yes"/>
    </Helmet>
  );
});

export const DefaultHeaders = memo(() => {
  const {t} = getLocalizationService();
  const translationKeysConfig = getTranslationKeysConfig();

  return (
    <MetaHeaders
      title={t(translationKeysConfig.default.title)}
      description={t(translationKeysConfig.default.description)}
      keywords={t(translationKeysConfig.default.keywords)}
    />
  );
});
